import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { Table, TableBody, TableCell, TableHead, TableRow, Tooltip, IconButton } from '@mui/material';
import EngineScoringClassificationCategoryListItemComponent from './EngineScoringClassificationCategoryListItemComponent';
import { Typography } from '@totalsoft/rocket-ui';
import { Add } from '@mui/icons-material';
import { getErrors } from '@totalsoft/pure-validations-react';

const EngineScoringClassificationCategoryListComponent = ({
  categories,
  engineClassificationIndex,
  isReadOnly,
  dispatch,
  scoringCategoryOptions,
  validation
}) => {
  const { t } = useTranslation();
  const onAddNewCategory = () => {
    dispatch({
      type: 'OnAddNewClassificationCategory',
      classificationIndex: engineClassificationIndex
    });
  };

  return (
    <>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>{t('EngineScoring.EngineClassifications.EngineCategory.OrderNo')}</TableCell>
            <TableCell>{t('EngineScoring.EngineClassifications.EngineCategory.CategoryName')}</TableCell>
            <TableCell>{t('EngineScoring.EngineClassifications.EngineCategory.ReadOnly')}</TableCell>
            <TableCell>{t('EngineScoring.EngineClassifications.EngineCategory.Mandatory')}</TableCell>
            <TableCell></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {categories.map((item, idx) => {
            return (
              <EngineScoringClassificationCategoryListItemComponent
                key={idx}
                category={item}
                dispatch={dispatch}
                categoryIndex={idx}
                classificationIndex={engineClassificationIndex}
                scoringCategoryOptions={scoringCategoryOptions}
                validation={validation[idx]}
                isReadOnly={isReadOnly}
              />
            );
          })}
        </TableBody>
      </Table>
      <Typography color='error'>{validation |> getErrors}</Typography>
      <Tooltip title={t('Tooltips.EngineScoringGrid.AddCategory')}>
        <span>
          <IconButton onClick={onAddNewCategory} color='primary' disabled={isReadOnly}>
            <Add />
          </IconButton>
        </span>
      </Tooltip>
    </>
  );
};

EngineScoringClassificationCategoryListComponent.propTypes = {
  categories: PropTypes.array.isRequired,
  isReadOnly: PropTypes.bool.isRequired,
  scoringCategoryOptions: PropTypes.array.isRequired,
  dispatch: PropTypes.func.isRequired,
  engineClassificationIndex: PropTypes.number.isRequired,
  validation: PropTypes.object.isRequired
};

export default EngineScoringClassificationCategoryListComponent;
